import { RouteType } from "types/RouteType";
import MeetingsStore from "./MeetingsStore";

const meetingsRoute: RouteType[] = [
  {
    name: "Meetings",
    path: "/meetings",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Meetings",
        enableRefreshButton: true,
        component: () => import("./Meetings.Header"),
      },
      body: {
        component: () => import("./Meetings.Body"),
        grayBackground: true,
      },
    },
    group: "Meeting Intelligence",
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = rootStore.readAiMeetingsViewStore as MeetingsStore;
      store?.load();
    },
    onExit: ({ rootStore }) => {
      // Tear down the live subscription so the socket handler doesn't leak.
      (rootStore.readAiMeetingsViewStore as MeetingsStore)?.dispose();
    },
  },
];

export default meetingsRoute;
